/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_MobileInputs */

const en_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const ar_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جوال`)
};

const bn_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোবাইল`)
};

const de_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil`)
};

const es_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Móvil`)
};

const fr_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const pt_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const zh_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动`)
};

const tr_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const ru_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const pl_svcat_mobile = /** @type {(inputs: Svcat_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

/**
* | output |
* | --- |
* | "Mobile" |
*
* @param {Svcat_MobileInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_mobile = /** @type {((inputs?: Svcat_MobileInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_MobileInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_mobile(inputs)
	if (locale === "bn") return bn_svcat_mobile(inputs)
	if (locale === "de") return de_svcat_mobile(inputs)
	if (locale === "es") return es_svcat_mobile(inputs)
	if (locale === "fr") return fr_svcat_mobile(inputs)
	if (locale === "pt") return pt_svcat_mobile(inputs)
	if (locale === "zh") return zh_svcat_mobile(inputs)
	if (locale === "tr") return tr_svcat_mobile(inputs)
	if (locale === "ru") return ru_svcat_mobile(inputs)
	if (locale === "pl") return pl_svcat_mobile(inputs)
	return en_svcat_mobile(inputs)
});